export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x970B065B572CC0118535Ad1101663CDBE7Db1e21",
  eulerSwapV1Implementation: "0x2b07caff83C15c5a70C4C0867DFE7A0BE01025B0",
  eulerSwapV1Periphery: "0x0de305aB93902914909951A00079ea1df3FD98eA",
} as const
